// import * as fs from "fs";
import { injectable } from 'inversify';
import 'reflect-metadata';
import axiosClient from './axios-client';
import { UserPowerBIDashboardFeedbackFormRequest } from '../models/feedback/create-dashboard-feedback-request.model';
import { ERRORS } from '../constants';
import { ApiResponse } from '../utils/api-response.utils';

@injectable()
export class FeedbackService {
  async createDashboardFeedback(
    request: UserPowerBIDashboardFeedbackFormRequest
  ): Promise<ApiResponse<boolean | null>> {
    try {
      const response = await axiosClient.post<ApiResponse<boolean | null>>(
        `/api/user-feedback/create`,
        request
      );

      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
